import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbProgressbarConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addpersonzone',
  templateUrl: './addpersonzone.component.html'
})
export class AddPersonZoneComponent {
  @Input('showAddMyself') showAddMyself: boolean = false;
  @Input('maxPersonAmount') maxPersonAmount?: number;
  @Input('dossierPersonsAmount') dossierPersonsAmount: number = 0;
  @Output('OnFileSelected') onFileSelected = new EventEmitter();
  @Output('addMyself') AddMyself = new EventEmitter();
  @Output('addPerson') AddPerson = new EventEmitter();
  
  addPerson() {
    this.AddPerson.emit();
  }

  addMyself() {
    this.AddMyself.emit();
  }
}
